exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".records-list-component[data-v-33f9b366] {\n  width: 100%;\n}\n.photo[data-v-33f9b366] {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}", ""]);

// exports
